export default function getRatio() {
    return window.devicePixelRatio ? window.devicePixelRatio : 2;
}
//# sourceMappingURL=get-ratio.js.map